import {UnsupportedNodeConverter} from './UnsupportedNodeConverter'

const UnsupportedBlockNodeConverter = {
    type: 'unsupportedblocknode',

    matchElement: function(el) {
        return el.is('object')
    },

    import: UnsupportedNodeConverter.import,
    export: UnsupportedNodeConverter.export
}

export {UnsupportedBlockNodeConverter}
